
import { computed, defineComponent, ref, watch } from "vue";
import { LeaderboardUser } from "@/types";
import { userService } from "@/services/user.service";
import Tabs from "@/components/UI/Tabs.vue";

export default defineComponent({
  name: "Leaderboard",
  components: {
    Tabs,
  },

  setup() {
    const users = ref<LeaderboardUser[]>([]);
    const limit = 20;
    let offset = 0;
    const reachedEnd = ref(false);

    const tabs = ref([
      { text: "Last Week", data: 7 },
      { text: "Last Month", data: 31 },
      { text: "Last Year", data: 365 },
    ]);
    const selectedIndex = ref(0);
    const n = computed(() => tabs.value[selectedIndex.value].data);

    const getUsers = async () => {
      const result = await userService.getTopByXp(limit, offset, n.value);
      users.value.push(...result);
      if (result.length < limit) reachedEnd.value = true;
      offset += limit;
    };
    getUsers();

    watch(
      () => n.value,
      () => {
        reachedEnd.value = false;
        users.value = [];
        offset = 0;
        getUsers();
      }
    );

    return {
      users,
      getUsers,
      tabs,
      reachedEnd,
      selectedIndex,
    };
  },
});
